/* eslint-disable consistent-return */
import { getRegisterPhotoLabel } from './registerPhotoLabel';

const returnType = (
  DFTIPOREGISTRO:
    | 'A'
    | 'D'
    | 'F'
    | 'C'
    | 'N'
    | 'G'
    | 'Q'
    | 'R'
    | 'S'
    | 'T'
    | 'O'
    | 'P'
    | 'K'
    | '1'
    | '2'
    | null,
) => {
  switch (DFTIPOREGISTRO) {
    case 'A':
      return 'Inicio da coleta';
    case 'D':
      return 'Descarga da coleta';
    case 'F':
      return 'Fim da coleta';
    case 'C':
      return 'Coleta em propriedade';
    case 'N':
      return 'Não coletado';
    case 'G':
      return 'Geolocalização da coleta';
    case 'Q':
      return 'Qualidade de leite';
    case 'R':
      return getRegisterPhotoLabel('R');
    case 'S':
      return getRegisterPhotoLabel('S');
    case 'T':
      return 'Temperatura do leite';
    case 'O':
      return 'Ocorrência em propriedade';
    case 'P':
      return 'Parada Prolongada';
    case '1':
      return 'Odômetro Inicial';
    case '2':
      return 'Odômetro final';
    case 'K':
      return 'Localização do tanque';
    default:
      return null;
  }
};

const returnRegisterType = (
  DFTIPOREGISTRO:
    | 'A'
    | 'D'
    | 'F'
    | 'C'
    | 'N'
    | 'G'
    | 'Q'
    | 'R'
    | 'S'
    | 'T'
    | 'O'
    | 'P'
    | 'K'
    | '1'
    | '2'
    | null,
  DFTIPOITEMCOLETA?: 'C' | 'N' | 'S',
) => {
  if (DFTIPOREGISTRO && !DFTIPOITEMCOLETA) {
    return returnType(DFTIPOREGISTRO);
  }
  if (DFTIPOREGISTRO && DFTIPOITEMCOLETA) {
    if (DFTIPOREGISTRO === 'C' && DFTIPOITEMCOLETA === 'C') {
      return 'Coleta em propriedade';
    }
    if (DFTIPOREGISTRO === 'N' && DFTIPOITEMCOLETA === 'C') {
      return 'Coleta em andamento';
    }
    if (DFTIPOREGISTRO === 'O' && DFTIPOITEMCOLETA === 'C') {
      return 'Ocorrência em propriedade';
    }
    if (DFTIPOREGISTRO === 'C' && DFTIPOITEMCOLETA === 'S') {
      return 'Socorro em propriedade';
    }
    if (DFTIPOREGISTRO === 'N' && DFTIPOITEMCOLETA === 'S') {
      return 'Socorro em andamento';
    }
    if (DFTIPOREGISTRO === 'O' && DFTIPOITEMCOLETA === 'S') {
      return 'Ocorrência em propriedade';
    }
    if (DFTIPOREGISTRO === 'O' && DFTIPOITEMCOLETA === 'N') {
      return 'Ocorrência em propriedade';
    }
    if (DFTIPOREGISTRO === 'N' && DFTIPOITEMCOLETA === 'N') {
      return 'Coleta em andamento';
    }
  }
};

export { returnRegisterType, returnType };
